import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  private spinnerState$ = new BehaviorSubject<boolean>(false);
  private excludeLoadingSpinner$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  get loadingState$(): Observable<boolean> {
    return this.spinnerState$.asObservable();
  }

  show(): void {
    setTimeout(() => this.spinnerState$.next(true), 0);
  }

  hide(): void {
    setTimeout(() => this.spinnerState$.next(false), 0);
  }

  setExcludeLoadingSpinner(excludeLoadingSpinner: boolean): void {
    this.excludeLoadingSpinner$.next(excludeLoadingSpinner);
  }

  getExcludeLoadingSpinner$(): BehaviorSubject<boolean> {
    return this.excludeLoadingSpinner$;
  }
}
